export default ({ store, app }, inject) => {
    inject('messages', {
        add({ type, message, id }) {
            store.dispatch('messages/addMessage', { type, message, id })
        },
        addFlash({ type, message, persist }) {
            store.dispatch('messages/addFlashMessage', { type, message })
        },
        addPersistentFlash({ type, message }) {
            const flashMessage = { type, message }

            localStorage.setItem('flashMessage', JSON.stringify(flashMessage))
        },
        clear({ messageId } = {}) {
            store.dispatch('messages/clearMessages', { messageId })
        },
    })
}
